import $ from 'jquery';

$(function () {
  var $gear = $('.js-icon-settings');

  if (!$gear.length) {
    return;
  }

  var now = new Date();
  var day = now.getDate();
  var month = now.getMonth() + 1;

  var april = 4;
  var first = 1;

  if (month == april && day == first) {
    $gear.addClass('spinning');
  }
});
